__turbopack_context__.v({
  "buttonContainer": "ErrorState-module-scss-module__K8h-Aq__buttonContainer",
  "container": "ErrorState-module-scss-module__K8h-Aq__container",
  "content": "ErrorState-module-scss-module__K8h-Aq__content",
  "errorIcon": "ErrorState-module-scss-module__K8h-Aq__errorIcon",
  "iconContainer": "ErrorState-module-scss-module__K8h-Aq__iconContainer",
  "message": "ErrorState-module-scss-module__K8h-Aq__message",
  "title": "ErrorState-module-scss-module__K8h-Aq__title",
});
